import React from "react";

import {
  type ITimeGranularity,
  TimeGranularity_Deprecated,
} from "@north-beam/nb-common";

import { type ExtendableSelectProps } from "./select";

import { Select } from ".";

interface TimeGranularitySelectProps extends ExtendableSelectProps {
  label?: string | React.ReactElement;
  className?: string;
  isLoading?: boolean;
  timeGranularity: ITimeGranularity;
  onChange: (obj: any) => void;
}

export const TimeGranularitySelect = ({
  label,
  className,
  isLoading = false,
  timeGranularity,
  onChange,
  ...props
}: TimeGranularitySelectProps) => {
  return (
    <Select
      label={label ?? "TIME GRANULARITY"}
      className={className}
      isLoading={isLoading}
      value={TimeGranularity_Deprecated.toReactSelect(timeGranularity).value}
      options={TimeGranularity_Deprecated.reactSelectOptions}
      icon={<i className="fa-regular fa-sharp fa-sitemap" />}
      onChange={onChange}
      {...props}
    />
  );
};
